<template>
  <div
    v-if="searchQuery"
    class="mt-5 overflow-hidden bg-white shadow-sm sm:rounded-lg"
  >
    <div
      class="flex px-4 py-5 hover:cursor-pointer sm:px-5"
      @click="$refs.collapseButton.click()"
    >
      <h3 class="grow text-lg leading-6 font-medium text-gray-900">
        {{ t('jobAlerts.searchQuery.title') }}
      </h3>
      <button
        ref="collapseButton"
        class="text-indigo-500 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-indigo-500"
        @click.stop="collapsePanel = !collapsePanel"
      >
        <ChevronDoubleUpIcon
          class="w-5 transition"
          :class="collapsePanel ? 'rotate-180' : ''"
        />
      </button>
    </div>
    <div
      class="border-t border-gray-200 transition-[max-height] duration-500"
      :class="!collapsePanel ? 'h-fit max-h-screen' : 'h-0 max-h-0'"
    >
      <dl class="sm:divide-y sm:divide-gray-200">
        <div
          v-for="(value, key) in searchQuery"
          :key="key"
          class="bg-white px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6"
        >
          <dt class="text-sm font-medium text-gray-500">
            {{ t(`jobAlerts.searchQuery.${key}`) }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:col-span-3 sm:mt-0">
            {{ value }}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { ChevronDoubleUpIcon } from '@heroicons/vue/24/outline'
import { useJobAlertStore } from '../../store/jobAlertStore'
import { getLocation } from '../../utils/location'

const jobAlertStore = useJobAlertStore()
const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})

const collapsePanel = ref(false)

const searchQuery = ref(null)
const geoLocation = ref({})

const search = jobAlertStore.jobAlert?.search
if (search) {
  const searchToDisplay = {}

  for (const prop in search) {
    if (['latitude', 'longitude', 'distance'].includes(prop)) {
      geoLocation.value[prop] = search[prop]
    } else {
      const value = search[prop]
      if (value) {
        const arrayVal = Array.isArray(value)
        if (arrayVal && value.length) {
          searchToDisplay[prop] = value.join(', ')
        } else if (!arrayVal) {
          searchToDisplay[prop] = value
        }
      }
    }
  }

  searchQuery.value = searchToDisplay
}

getLocation(geoLocation.value).then((location) => {
  if (location) {
    searchQuery.value.location = location.city
    searchQuery.value.distance = `${search.distance} km`
  }
})
</script>
